export default __webpack_public_path__ + "static/media/wiseeuslogo-02w-01.e2607543.png";